import { contracts } from "@wormhole-foundation/sdk-base";
/**
 *
 * Get the contracts for a given network and chain
 *
 * @param n the network to get contracts for
 * @param c the chain to get contracts for
 * @returns the contracts for the given network and chain
 */
export function getContracts(n, c) {
    const ct = {
        coreBridge: contracts.coreBridge.get(n, c),
        tokenBridge: contracts.tokenBridge.get(n, c),
        nftBridge: contracts.nftBridge.get(n, c),
        relayer: contracts.relayer.get(n, c),
        tokenBridgeRelayer: contracts.tokenBridgeRelayer.get(n, c),
        tbtc: contracts.tbtc.get(n, c),
    };
    if (contracts.circleContracts.has(n, c)) {
        ct.cctp = contracts.circleContracts.get(n, c);
    }
    if (contracts.gateway.has(n, c)) {
        ct.gateway = contracts.gateway.get(n, c);
    }
    if (contracts.translator.has(n, c)) {
        ct.translator = contracts.translator.get(n, c);
    }
    if (contracts.portico.has(n, c)) {
        ct.portico = contracts.portico.get(n, c);
    }
    if (contracts.tbtc.has(n, c)) {
        ct.tbtc = contracts.tbtc.get(n, c);
    }
    return ct;
}
//# sourceMappingURL=contracts.js.map